import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "us-east-1",
    aws_cognito_identity_pool_id: "us-east-1:ba3a4017-0bbb-4915-bbfb-2ca8486115a5",
    aws_user_pools_id: "us-east-1_FzXrRGH6Y",
    aws_user_pools_web_client_id: "da9e4osf64flht8ghiptu41gm",
    Auth: {
      identityPoolId: "us-east-1:ba3a4017-0bbb-4915-bbfb-2ca8486115a5",
      region: "us-east-1",
      userPoolId: "us-east-1_FzXrRGH6Y",
      userPoolWebClientId: "da9e4osf64flht8ghiptu41gm",
    },
    oauth: {
      domain: `whs-data-excavator-prod-na.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://prod.na.excavator.whs.amazon.dev",
      redirectSignOut: "https://prod.na.excavator.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
